<template>
  <div>
    <vs-tabs class="organization-details">
      <vs-tab label="Organisation Details">
        <div><OrganizationDetails /></div>
      </vs-tab>
      <vs-tab label="Clinics">
        <div><OrganizationClinics :canAssignClinic="true" /></div>
      </vs-tab>
      <vs-tab label="Users & Accounts">
        <div>
          <OrganizationAccountsAndUsers :canAssignClinic="false" />
        </div>
      </vs-tab>
      <vs-tab label="Treatments">
        <div><OrganizationTreatments /></div>
      </vs-tab>
      <vs-tab label="Invoices">
        <div>
          <Invoices :clinicId="'all'" />
        </div>
      </vs-tab>
      <vs-tab label="Orders">
        <div>
          <OganizationOrders />
        </div>
      </vs-tab>
      <vs-tab label="Compliance">
        <monthlyComplianceList/>
      </vs-tab>
      <vs-tab label="Settings">
        <div><OrganizationSettings /></div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import OrganizationDetails from '../../components/organization/organizationDetails.vue';
import OrganizationAccountsAndUsers from '../../organization/users/organizationAccountsAndUsers.vue';
import OrganizationTreatments from '../../organization/treatments/organizationTreatments.vue';
import OrganizationClinics from '../../organization/clinic/organizationClinics.vue';
import OganizationOrders from '../../organization/orders/oganizationOrders.vue';
import Invoices from '../../organization/invoices/List.vue';
import OrganizationSettings from '../../organization/settings/organizationSettings.vue';
import monthlyComplianceList from '../../organization/monthly-compliance/complianceList.vue';

export default {
  components: {
    OrganizationDetails,
    OrganizationAccountsAndUsers,
    OrganizationClinics,
    Invoices,
    OganizationOrders,
    OrganizationTreatments,
    OrganizationSettings,
    monthlyComplianceList,
  },
   data() {
    return {
    };
  },
  methods: {
  },
};
</script>
